<template>
  <div class="Study">
      <div class="study-main">
          <PageHeader :studyData='studyDatas'></PageHeader>
          <div class="content">
              <StudyMsg :studyData='studyDatas'></StudyMsg>
          </div>
      </div>
      <SidebarRight :studyData='studyDatas' ref="sidebar"></SidebarRight>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {getCourseDetail} from 'api/course'
import {uploadCourseJoinInfo} from 'api/api'
import PageHeader from './components/Header'
import SidebarRight from './components/Sidebar'
import StudyMsg from './components/StudyMsg'
import $ from 'jquery'

export default {
    name: 'Study',
    data() {
        return {
            studyDatas: {}, // 课程详情
            courseid: this.$route.query.courseid,   // 课程id
            message: null
        }
    },
    mounted() {
        $('.vm-header-seize').css('display','none')
        $('.vm-header').css('display','none')
        $('.footer').css('display','none')
        // 课程详情
        this.getStudyData()
    },
    methods: {
        gopay() {
             // 默认收费情况下
            let money = '¥',
                btnTxt = '立即购买'

            // 未付费/参与 同时登录情况下
            if (this.studyDatas.isjoin == 0 && this.user().isLogin == true) {
                if (this.studyDatas.feetype == 1) {
                   // 免费情况下
                   money = '免费'
                   btnTxt = '立即参与'
                } else {
                    money += this.studyDatas.saleprice
                }
                this.message = this.$message({
                    dangerouslyUseHTMLString: true,
                    duration: 0,
                    customClass: 'pay',
                    type: false,
                    message: '<div><p class="name">参加课程后可以完整学习课程，使用笔记和讨论。</p> <p class="money">'+money+'</p> <el-button round>'+btnTxt+'</el-button> </div>'
                })
                this.$nextTick(() => {
                    let $this = this
                    $('.pay').click(() => {
                        $this.pay($this.studyDatas)
                    })
                })
            }

        },
        getStudyData() {    // 获取课程详情
            this.setLoading(true)
            getCourseDetail({
                data: {courseid: this.courseid},
                success: data => {
                    this.setLoading(false)
                    this.studyDatas = data.data

                    // 提示弹窗
                    this.gopay()
                    console.log('studyData', this.studyDatas)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        pay(studyDatas) { // 前往支付购买
            // 付费课程前往购买
            if (studyDatas.feetype == 2) {
                const {href} = this.$router.resolve({
                    // name: 'OrderIndex', query: {'cid': this.$route.query.courseid}
                    name: 'OrderIndex', query: {'kmcinnerid': this.$route.query.courseid,'kmctype':7}
                })
                window.open(href,'_blank')
            } else if (studyDatas.feetype == 1) {
                 // 免费课程调用参与接口
                 this.uploadCourseJoinInfo()
            }

        },
         ...mapActions([
            'setLoading'
        ]),
        uploadCourseJoinInfo() {
            this.setLoading(true)
            uploadCourseJoinInfo({
                data: {courseid: this.$route.query.courseid},
                success: data => {
                    this.setLoading(false)
                    if (data.code == '000') {
                        this.$message.success('参与成功')
                        this.$router.go(0)
                    } else {
                        this.$message.error(data.msg)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
         ...mapGetters(['user']),
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        PageHeader,
        SidebarRight,
        StudyMsg,
       
    },
    // beforeRouteLeave(to, from , next) {
    //     console.log(this.$message.close)
        
    //     next()
    // },
    beforeDestroy() {
       $('.header').css('display','block')
       $('.footer').css('display','block')
       if (this.message) {
            this.message.close()
        }
    }
}
</script>

<style lang="scss" type="text/scss" scope>
.pay {
    background: #fff;
    .name {
        float: left;
        width: 210px;
        font-size: 14px;
        line-height: 20px;
    }
    .money {
        float: left;
        font-size:18px;
        font-weight:500;
        color:rgba(255,71,71,1);
        margin-left: 20px;
        margin-right: 40px;
        line-height: 42px;
    }
    el-button {
        margin-top: 5px;
        cursor: pointer;
        float: left;
        width:99px;
        height:30px;
        line-height: 30px;
        text-align: center;
        background:rgba(255,71,71,1);
        font-size:14px;
        color: #fff;
        border-radius:24px;
    }
}
.Study {
    // position: fixed;
    // z-index: 2;
    top: 0;
    width: 100%;
    height: 100vh;
    overflow-y: hidden;
    // background: #999;
    .content {
        position: absolute;
        width: 100%;
        /*height: 91.2%;*/
        height: calc(100% - 50px);
        min-height: 500px;
        // height: 100%;
        background: #999;
        padding-bottom: 50px;
        box-sizing: border-box;
        -webkit-transition: all .5s;
        -ms-transition: all .5s;
        -o-transition: all .5s;
        -moz-transition: all .5s;

        &.active {
            width: calc(100% - 420px);
            transition: all .5s;
            -webkit-transition: all .5s;
            -ms-transition: all .5s;
            -o-transition: all .5s;
            -moz-transition: all .5s;
        }


    }
    .study-main {
        width: 100%;
        transition: all .5s;
        -webkit-transition: all .5s;
        -ms-transition: all .5s;
        -o-transition: all .5s;
        -moz-transition: all .5s;

        &.active {
            width: calc(100% - 420px);
            transition: all .5s;
            -webkit-transition: all .5s;
            -ms-transition: all .5s;
            -o-transition: all .5s;
            -moz-transition: all .5s;
        }
    }
}
</style>